import React from 'react'
import next from "../../assets/forward-arrow.svg";

const Card = ({img, title, desc, buttonText, btnLink}) => {
  return (
    <div className="card">
        <img src={img} alt={title} className="first-img" />
        <div className="card-content">
          <h2 className="heading-sub">{title}</h2>
           <p className="sub-desc">
          {desc}
        </p>

        <a href={btnLink}>
              <button className="nav-get-started-btn">{buttonText} <img src={next} alt="next step arrow" /></button>
            </a>
        </div>
      </div>
  )
}

export default Card

